export const BUSINESS = {
  name: "AMAA Constructions",
  brand: "AMAA Design & Build",
  phone: "+1 (254) 523-7676",
  phoneHref: "tel:+12545237676",
  email: "info@amaaconstruction.com",
  address: "13880 N Stemmons Fwy, Farmers Branch, TX 75234",
  hours: "Mon–Fri 8 AM–6 PM · Sat 9 AM–3 PM",
  area: "Dallas–Fort Worth Metroplex",
  salesToolsUrl: "https://amaaconstruction.com/sales-tool",
};

// NOTE: These figures were carried over from the previous site and are
// FLAGGED for owner verification before final production deployment.
export const STATS = [
  { value: "10+", label: "Years of Experience" },
  { value: "300+", label: "Projects Completed" },
  { value: "100%", label: "Client Satisfaction" },
  { value: "5.0", label: "Average Rating" },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const MAIN_SERVICES = [
  {
    num: "01",
    title: "Kitchen Remodeling",
    copy: "Custom cabinetry, statement islands, premium countertops and complete layout transformations designed around the way you live.",
    image: "/images/kitchen.webp",
    alt: "High-end modern kitchen with marble waterfall island and walnut cabinetry",
  },
  {
    num: "02",
    title: "Bathroom Remodeling",
    copy: "Spa-inspired retreats featuring walk-in showers, soaking tubs, custom tile and high-end fixtures.",
    image: "/images/bathroom.webp",
    alt: "Spa-inspired luxury bathroom with soaking tub and natural stone tile",
  },
  {
    num: "03",
    title: "New Home Construction",
    copy: "Complete custom-home construction managed from foundation and framing through interiors and final walkthrough.",
    image: "/images/custom-homes.webp",
    alt: "Modern luxury custom home exterior with limestone and steel facade",
  },
  {
    num: "04",
    title: "Complete Home Renovations",
    copy: "Interior and exterior transformations, open-concept conversions, additions and structural improvements.",
    image: "/images/transformation.webp",
    alt: "Open-concept luxury living area after a complete home renovation",
  },
];

export const SUPPORT_SERVICES = [
  "Luxury Custom Homes",
  "Room Additions",
  "Interior Renovations",
  "Exterior Renovations",
  "Interior Design",
  "Material Selection",
  "Construction Management",
];

// Capability showcase data — structured so authentic AMAA project photography,
// locations and before/after sets can be swapped in later without rebuilding.
export const CAPABILITIES = [
  {
    category: "Luxury Custom Homes",
    title: "Ground-Up Custom Residences",
    copy: "Architectural homes designed and built from foundation to final walkthrough — proportion, light and material composed as one.",
    services: ["New Home Construction", "Construction Management", "Material Selection"],
    image: "/images/custom-homes.webp",
    alt: "Modern luxury custom home exterior with cantilevered upper volume",
  },
  {
    category: "Modern Kitchens",
    title: "Kitchens Built Around Living",
    copy: "Statement islands, custom cabinetry and premium stone — engineered for the way you cook, gather and entertain.",
    services: ["Kitchen Remodeling", "Custom Cabinetry", "Premium Countertops"],
    image: "/images/kitchen.webp",
    alt: "Luxury kitchen with marble island and custom walnut cabinetry",
  },
  {
    category: "Spa-Inspired Bathrooms",
    title: "Private Retreats",
    copy: "Walk-in showers, sculptural tubs, custom tile and warm light — bathrooms rebuilt as places of restoration.",
    services: ["Bathroom Remodeling", "Custom Tile", "High-End Fixtures"],
    image: "/images/bathroom.webp",
    alt: "Spa bathroom with freestanding tub and frameless glass shower",
  },
  {
    category: "Complete Home Transformations",
    title: "Whole-Home Reimagination",
    copy: "Open-concept conversions, structural improvements and full interior renewals that change how a home feels and flows.",
    services: ["Complete Renovations", "Structural Transformations", "Room Additions"],
    image: "/images/transformation.webp",
    alt: "Double-height open-concept living area with linear stone fireplace",
  },
  {
    category: "Interior Design & Finishes",
    title: "The Final Ten Percent",
    copy: "Cabinetry, stone, tile, flooring and fixtures curated and installed with obsessive attention to detail.",
    services: ["Interior Design", "Material Selection", "Flooring & Finishes"],
    image: "/images/interior-design.webp",
    alt: "Luxury material palette with stone, tile and bronze hardware samples",
  },
  {
    category: "Exterior Renovations",
    title: "Facades with Presence",
    copy: "Stone, wood, steel and glass exteriors that give an existing home an entirely new architectural identity.",
    services: ["Exterior Renovations", "Facade Renewal", "Outdoor Living"],
    image: "/images/exterior.webp",
    alt: "Renovated modern home exterior with wood soffits and stone entry wall",
  },
];

export const PROCESS_STEPS = [
  { num: "01", title: "Free Consultation", copy: "We listen first. Your goals, your home, your budget — understood before anything is drawn." },
  { num: "02", title: "Vision & Planning", copy: "Scope, feasibility and a clear roadmap. You know exactly what happens, when, and why." },
  { num: "03", title: "Design Development", copy: "Layouts, elevations and details refined with you until the design is unmistakably yours." },
  { num: "04", title: "Material Selection", copy: "Stone, wood, tile and fixtures curated together — every surface chosen with intention." },
  { num: "05", title: "Expert Construction", copy: "Organized crews, premium materials and communication you never have to chase." },
  { num: "06", title: "Final Walkthrough", copy: "Every detail inspected together. We hand over a home, not a punch list." },
];

export const WHY_POINTS = [
  { title: "Detail-Focused Craftsmanship", copy: "The joints you never see get the same care as the finishes you touch every day." },
  { title: "Premium Materials", copy: "Natural stone, real wood and fixtures chosen to age gracefully, not just photograph well." },
  { title: "Clear Communication", copy: "One point of contact, honest timelines and updates before you think to ask." },
  { title: "Organized Project Management", copy: "Sequenced trades, protected schedules and a site run with discipline." },
  { title: "Design-Conscious Construction", copy: "Builders who read drawings like architects — proportion and alignment are non-negotiable." },
  { title: "Personalized Experience", copy: "A small number of projects at a time, so yours is never a line item." },
  { title: "Complete Coordination", copy: "Design, permits, trades and finishes coordinated under one accountable roof." },
];
